import React, { useEffect, useState } from 'react';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';

export default function Provenance() {
  const [hashOfHashes, setHashOfHashes] = useState('LOADING');
  const [indexHashData, setIndexHashData] = useState([
    {
      initial_sequence_index: 'LOADING',
      assigned_token_id: 'LOADING',
      image_hash: 'LOADING',
    },
  ]);

  useEffect(() => {
    fetch('/hash_of_hashes.txt')
      .then((r) => r.text())
      .then((text) => {
        setHashOfHashes(text);
      });
  }, [setHashOfHashes]);

  useEffect(() => {
    fetch('/every_nft_hash.json')
      .then((r) => r.json())
      .then((json) => {
        setIndexHashData(json);
      });
  }, [setIndexHashData]);

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="provenance"
    >
      <Helmet>
        <title>Provenance - DuskBreakers</title>
        <meta
          name="description"
          content="This page presents the provenance record of each DuskBreaker that will ever exist."
        />
      </Helmet>
      <section>
        <div className="container">
          <div className="row">
            <div className="col">
              <h1 className="mb-4">Provenance</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col">
              <p className="mb-4">
                This page presents the provenance record of each DuskBreaker that will ever exist.
                Each DuskBreaker image is firstly hashed using SHA-256 algorithm. A combined string
                is obtained by concatenating SHA-256 of each DuskBreaker image in the specific order
                as listed below. The final proof is obtained by SHA-256 hashing this combined
                string. This is the final provenance record stored on the smart contract. The final
                token id is assigned an image by the following formula.
              </p>
              <div className="prov-formula">
                (tokenId + startingIndex) % 10000 → Initial Sequence Index
              </div>
            </div>
          </div>

          <hr />

          <div className="row d-flex justify-content-center">
            <div className="col">
              <h2 className="text-start mb-5">Important Information</h2>

              <dl className="row mb-4 text-small overflow-auto">
                <dt className="col-6 col-lg-3">Finalized Starting Index</dt>
                <dd className="col-6 col-lg-9">2986</dd>

                <dt className="col-6 col-lg-3">DuskBreakers Contract Address</dt>
                <dd className="col-6 col-lg-9">
                  <a
                    href={'https://etherscan.io/address/0x0bEed7099AF7514cCEDF642CfEA435731176Fb02'}
                  >
                    0x0bEed7099AF7514cCEDF642CfEA435731176Fb02
                  </a>
                </dd>

                <dt className="col-6 col-lg-3">Final Provenance Hash</dt>
                <dd className="col-6 col-lg-9">
                  6a0fb9e7a4b14c965ff6d2d55d32b74f528268f0ec9872e831a6b33ae44fb021
                </dd>

                <dt className="col-6 col-lg-3">
                  {' '}
                  Initial Generator Seed (last digits of the Contract Owner Address)
                </dt>
                <dd className="col-6 col-lg-9"> 14187460 </dd>
              </dl>

              <div className="card">
                <div className="card-body">
                  <SimpleBar
                    autoHide={false}
                    forceVisible="y"
                    style={{
                      height: '3rem',
                    }}
                  >
                    <div className="prov-hash-string">{hashOfHashes}</div>
                  </SimpleBar>
                </div>
              </div>

              <div className="row d-flex justify-content-center">
                <div className="col">
                  <h2 className="text-start">Provenance Record</h2>

                  <p>
                    The table below lists the original index, assigned DuskBreakers Token ID, SHA256
                    Hash output and Image link of each DuskBreakers image.
                  </p>

                  <div className="card">
                    <div className="card-body">
                      <SimpleBar
                        autoHide={false}
                        forceVisible="y"
                        style={{
                          height: '20rem',
                        }}
                      >
                        <div>
                          <table className="table text-small table-sm table-borderless">
                            <thead>
                              <tr>
                                <th>Initial Sequence Index</th>
                                <th>Assigned DB Token ID</th>
                                <th>SHA-256 Hash</th>
                                <th>Final URL</th>
                              </tr>
                            </thead>
                            <tbody>
                              {indexHashData.map((el) => {
                                return (
                                  <tr key={'row-' + el.initial_sequence_index}>
                                    <td key={'si-' + el.initial_sequence_index}>
                                      {' '}
                                      {el.initial_sequence_index}{' '}
                                    </td>
                                    <td key={'at-' + el.initial_sequence_index}>
                                      {' '}
                                      {el.assigned_token_id}{' '}
                                    </td>
                                    <td key={'ih-' + el.initial_sequence_index}>
                                      {' '}
                                      {el.image_hash}{' '}
                                    </td>
                                    <td key={'img-' + el.initial_sequence_index}>
                                      <a
                                        href={
                                          'https://duskbreakers.gg/breaker_images/' +
                                          el.assigned_token_id +
                                          '.png'
                                        }
                                      >
                                        Breaker #{el.assigned_token_id}{' '}
                                      </a>
                                    </td>
                                  </tr>
                                );
                              })}
                            </tbody>
                          </table>
                        </div>
                      </SimpleBar>
                    </div>
                  </div>
                </div>
              </div>

              <p className="mt-4 text-small">
                Update 12/05/2021 02:23PM PST: In doing our due diligence on our NFT image mint, we
                noticed that we were missing the initial image from our provenance hash list, which
                means you couldn’t check our work. Since the Starting Index has not been set because
                the mint has not completed, we have updated our provenance hash to correctly match
                our images and traits to ensure a fair mint. Since the actual NFT you get is given
                by the formula of
                <b>(tokenId + startingIndex) % 10000 → Initial Sequence Index</b>, neither we nor
                anyone else can know what images or traits anyone would receive.
              </p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
